import { render, staticRenderFns } from "./TextContributionIndexCardContainer.vue?vue&type=template&id=64dc2618&scoped=true"
import script from "./TextContributionIndexCardContainer.vue?vue&type=script&lang=js"
export * from "./TextContributionIndexCardContainer.vue?vue&type=script&lang=js"
import style0 from "./TextContributionIndexCardContainer.vue?vue&type=style&index=0&id=64dc2618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc2618",
  null
  
)

export default component.exports